(function(window) { var svs = window.svs || {}; svs.modules = svs.modules || []; if(svs.modules.indexOf('/modules/lyckoplatsen/components/page-result/assets/react/components/win-amount-interval.js') >= 0) return;  svs.modules.push('/modules/lyckoplatsen/components/page-result/assets/react/components/win-amount-interval.js');

'use strict';

const formatCurrency = svs.utils.format.Currency;
const {
  selectedSpanResultsAtom
} = svs.lyckoplatsen.components.shared_result.jotai.atoms;
const {
  useAtomValue
} = jotai;
const WinAmountInterval = () => {
  const spanResults = useAtomValue(selectedSpanResultsAtom);
  const totalDrawCount = spanResults.results.length;
  const totalWinAmount = spanResults.results.reduce((total, result) => total + parseInt(result === null || result === void 0 ? void 0 : result.totalWinAmountSek, 10), 0);
  return React.createElement("div", {
    className: "fc-white u-text-center"
  }, React.createElement("h1", {
    className: "f-700 f-bold margin-top-2 margin-bottom-1"
  }, "Total vinstsumma f\xF6r ", totalDrawCount, " dragningar:"), React.createElement("h1", {
    className: "f-900 f-bold margin-top-0"
  }, formatCurrency(totalWinAmount), " kr"));
};
Object.assign(svs.lyckoplatsen.components.page_result.react.components, {
  WinAmountInterval
});

 })(window);